/**
 * UUID generato in modo sicuro anche FUORI da un secure context.
 *
 * `crypto.randomUUID()` è disponibile solo in secure context (HTTPS o
 * localhost). Su `http://<IP>:porta` (es. istanze dev servite via IP) è
 * `undefined` → `TypeError: crypto.randomUUID is not a function`, che nei
 * tracker analytics faceva crashare l'intera pagina (error boundary →
 * "pagina non trovata"). Questo helper degrada con grazia.
 *
 * Solo per id non crittografici (session id analytics, key UI). Per id DB
 * lato server usare `crypto.randomUUID()` di Node (sempre disponibile).
 */
export function safeUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback RFC4122-v4 via getRandomValues (disponibile anche su http).
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, '0'));
    return `${h.slice(0, 4).join('')}-${h.slice(4, 6).join('')}-${h.slice(6, 8).join('')}-${h.slice(8, 10).join('')}-${h.slice(10, 16).join('')}`;
  }
  // Ultima spiaggia (no Web Crypto): non crittografico, basta per session id.
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}-${Math.random().toString(16).slice(2, 10)}`;
}
